"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = void 0;
var React = require("react");
require("./Dialog.scss");
var Dialog = function (props) {
    var _a = React.useState(props.isOpen || false), isOpen = _a[0], setIsOpen = _a[1];
    var openDialog = function () {
        setIsOpen(true);
    };
    var closeDialog = function (event) {
        if (event.target === event.currentTarget) {
            setIsOpen(false);
        }
    };
    return (React.createElement("div", { className: "spot-dialog" },
        isOpen && (React.createElement("div", { className: "dialog", onClick: closeDialog },
            React.createElement("div", { className: "dialog-content-wrapper", style: props.dialogStyle },
                props.closeIcon && (React.createElement("span", { className: "close" },
                    React.createElement("i", { className: "icon-cancel-V2", onClick: closeDialog }))),
                React.createElement("div", { className: "dialog-header" },
                    React.createElement("h2", null, props.header)),
                React.createElement("div", { className: "dialog-content" }, props.children)))),
        React.createElement("a", { onClick: openDialog, className: "dialog-trigger" },
            props.triggerComponent,
            props.triggerIcon && React.createElement("i", { className: props.triggerIcon }),
            props.triggerText)));
};
exports.Dialog = Dialog;
//# sourceMappingURL=Dialog.js.map